<template>
  <div class="bank-container">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/06/icon_bank.png"
           alt="">
      银行管理
    </div>
    <el-form ref="form"
             class="banklist_search"
             :inline="true">
      <el-form-item label="银行名称">
        <el-autocomplete class="inline-input"
                         size='small'
                         v-model="inputName"
                         :fetch-suggestions="querySearch"
                         placeholder="请输入内容"
                         :trigger-on-focus="false">
        </el-autocomplete>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   size="small"
                   class="search_btn"
                   @click="handleSearchBankClick">
          查询
        </el-button>
      </el-form-item>
      <el-form-item class="btn_box">
        <router-link to="bank/addBank">
          <el-button type="warning"
                     size="small"
                     class="add_btn">
            添加
          </el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <div class="bank_table">
      <el-table :data="bankList.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         fixed
                         label="序号"
                         align="center"
                         type="index"
                         width="50">
        </el-table-column>
        <el-table-column prop="bankName"
                         header-align="center"
                         align="center"
                         label="银行名称"
                         min-width="130">
          <template slot-scope="scope">
            <div size="medium">{{scope.row.bankName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="bankNum"
                         label="银行编码"
                         header-align="center"
                         align="center"
                         min-width="70">
          <template slot-scope="scope">
            <div>{{scope.row.bankNum}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime"
                         label="更新时间"
                         header-align="center"
                         align="center"
                         min-width="94">
          <template slot-scope="scope">
            <div>{{scope.row.createTime}}</div>
          </template>
        </el-table-column>

        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="175">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.bankId)"></el-button>
            </el-tooltip>
            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleBankDelete(scope.row.bankId)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{bankList.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="bankList.pageSize"
                     layout="prev, pager, next"
                     :total="bankList.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { bankList, deleteBank } from '../../apis/index'
// import { mapState } from 'vuex'
export default {
  name: 'Container',
  data () {
    return {
      bankList: [],
      inputName: ''
    }
  },
  // computed: mapState({
  //   showAddBank: state => state.bank.show
  // }),
  mounted () {
    this.getBankList()
  },
  methods: {
    getBankList () { // 获取所有银行列表
      bankList().then(res => {
        if (res.data.code === 0) {
          this.bankList = res.data.data.pagination
        }
      })
    },
    handleCurrentChange (val) { // 分页
      let pageNum = val
      bankList({ pageNum }).then(res => {
        this.bankList = res.data.data.pagination
      })
    },
    querySearch (queryString, cb) { // 模糊查询
      var csvS = this.csvS
      cb(csvS)
    },
    createFilter (queryString) { // 模糊查询
      return (bankList) => {
        return (bankList.bankName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    // handleAddClick () { // 跳转添加页面
    //   this.$store.commit('bank/showAddBank', true)
    //   const bankInfo = {}
    //   this.$store.commit('bank/updateBank', bankInfo)
    // },
    handleBankDelete (item) { // 删除银行信息
      deleteBank({ bankId: item }).then(res => {
        if (res.data.code === 0) {
          for (var i = 0; i < this.bankList.result.length; i++) { // 从当前列别表中删除该数据
            if (this.bankList.result[i].bankId === item) {
              this.bankList.result.splice(i, 1)
            }
          }
        }
      })
    },
    handleUpdateClick (item) { // 修改银行信息
      this.$router.push({ path: 'bank/addBank', query: { item: item } })
      // let bankId = item
      // updateBank({ bankId }).then(res => {
      //   if (res.data.code === 0) {
      //     this.$store.commit('bank/showAddBank', true)
      //     const bankInfo = res.data.data.vhbBankName
      //     this.$store.commit('bank/updateBank', bankInfo)
      //   }
      // })
    },
    handleSearchBankClick () { // 查询银行信息
      bankList({ bankName: this.inputName }).then(res => {
        if (res.data.code === 0) {
          this.bankList = res.data.data.pagination
        }
      })
    }
  },
  watch: {
    inputName: function () { // 模糊查询
      this.csvS = []
      var len = this.bankList.result.length
      var arr = []
      for (var i = 0; i < len; i++) {
        if (this.bankList.result[i].bankName.indexOf(this.inputName) >= 0) {
          arr.push(this.bankList.result[i])
        }
      }
      // el-autocomplete元素要求数组内是对象，且有value属性
      for (var j = 0; j < arr.length; j++) {
        var obj = { value: '' }
        obj.value = arr[j].bankName
        this.csvS.push(obj)
      }
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.bank-container
  height 100%
  padding 20px
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    border-bottom 1px solid #cfd5dc
    .title_img
      background #9231ff
      border-radius 50%
  .banklist_search
    width 100%
    position relative
    .el-form-item
      margin-bottom 5px
    .search_btn
      searchBtn()
    .btn_box
      width 80px
      float right
      position absolute
      top 0
      right 0
      .add_btn
        addBtn()
    .el-input
      margin-left 10px
      width 210px
  .bank_table
    height calc(100% - 164px)
    .el-table
      background #f7f9fb
      th
        background #e7f0f8
        .cell
          height 25px
          line-height 25px
      td
        .cell
          size12()
          .el-button
            padding 6px 14px
            width 28px
            cursor pointer
            height 28px
            margin 0 8px
            &.update
              update()
            &.delete
              delete()
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin 15px 20px 0
  .demonstartion
    float right
    line-height 45px
    color #5e656f
</style>
